import axios from "axios";
import React, { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ServiceUrl } from "../../utils/serviceUrl";
import { COLLEGE_UUID, DB_POSTFIX, IMAGES_512 } from "../../utils";
import PsContext from "../../context";

const Announcements = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    listData();
  }, []);

  const listData = () => {
    setLoader(true);
    axios
      .get(
        ServiceUrl.LIST_PAGES +
          "?college_uuid=" +
          COLLEGE_UUID +
          "&type=announcement&upcoming=1"
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          //  console.log(res["data"].data);
        }
        setLoader(false);
      });
  };

  const marqueeMouseOver = () => {
    document.getElementById("adm_top_marquee").stop();
  };

  const marqueeMouseOut = () => {
    document.getElementById("adm_top_marquee").start();
  };

  return (
    <div
      style={{
        borderRadius: "3px",
      }}
    >
      <div className="home-top-cour-desc">
        <Card>
          <Card.Header className="fw-bold text-center h5">
            Latest News
          </Card.Header>
          <Card.Body>
            <marquee
              direction="up"
              style={{ height: "800px" }}
              scrollAmount="3"
              onMouseOver={(e) => marqueeMouseOver()}
              onMouseOut={(e) => marqueeMouseOut()}
              id="adm_top_marquee"
            >
              {dataList.map((item) => {
                return item.show_new_blink_img &&
                  item.show_new_blink_img == "1" ? (
                  <Row className="border-bottom pb-2 mb-2">
                    <Col md={1} className="d-none d-sm-block">
                      <img
                        src={IMAGES_512.NEW_GIF.default}
                        style={{ width: "40px" }}
                      />
                    </Col>
                    <Col md={11}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.content_html,
                        }}
                      />
                    </Col>
                  </Row>
                ) : (
                  <Row className="border-bottom pb-2 mb-2">
                    <Col md={12}>
                      <div
                        dangerouslySetInnerHTML={{ __html: item.content_html }}
                      />
                    </Col>
                  </Row>
                );
              })}
            </marquee>
          </Card.Body>
          <Card.Footer className="text-center bg-white">
            <Link to="/announcements-list">View All</Link>
          </Card.Footer>
        </Card>
      </div>
    </div>
  );
};

export default Announcements;
